import { setDoc, doc, getFirestore, deleteDoc } from 'firebase/firestore';

/**
 * Used to mimic FirebaseDoc
 *
 * Contains "data" property which is passed through constructor
 * And a full path of the document used as "id"
 */
class FirebaseCollectionItem {
  constructor(data, path, id) {
    this.data = data;
    this.path = path;
    this.id = id; // full path
    this.doc = doc(getFirestore(), `${this.path}/${this.id}`);
  }

  update(data) {
    return setDoc(this.doc, data, {
      merge: true,
    });
  }

  delete() {
    return deleteDoc(this.doc);
  }
}

export default FirebaseCollectionItem;
